import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { TotalesDeLaOrden } from '@/lib/supabase/tipos-bd'

/**
 * CUÁNTO VA LA OBRA.
 *
 * La orden no tenía total: arriba el valor de la cotización principal y más
 * abajo los adicionales con otra suma, como si fueran cosas distintas. No lo
 * son —es la misma obra—, y la pregunta que alguien se hace mirando esa
 * pantalla es cuánto va en total.
 *
 * Lo calcula la base y no el navegador a propósito: la cifra tiene que dar lo
 * mismo aquí, en el tablero y en cualquier informe, y eso solo se consigue
 * con una única definición de qué suma y qué no.
 */
export function useTotalesDeLaOrden(ordenServicioId: string | null) {
  const consulta = useQuery({
    // Bajo la clave de la orden, por lo mismo que los documentos: el total
    // se quedaba sin sumar el adicional recién enlazado.
    queryKey: ['ordenes-servicio', 'totales', ordenServicioId],
    enabled: Boolean(ordenServicioId),
    queryFn: async (): Promise<TotalesDeLaOrden | null> => {
      const { data, error } = await supabase.rpc('fn_totales_de_la_orden', {
        p_orden_servicio_id: ordenServicioId!,
      })

      if (error) throw new Error(mensajeDeError(error))

      const fila = (data as unknown as TotalesDeLaOrden[] | null)?.[0]
      if (!fila) return null

      return {
        ...fila,
        aprobado: Number(fila.aprobado),
        en_propuesta: Number(fila.en_propuesta),
        facturado: Number(fila.facturado),
        pendiente_de_cobrar: Number(fila.pendiente_de_cobrar),
      }
    },
  })

  return { totales: consulta.data ?? null, cargando: consulta.isLoading }
}
